import React, {Component} from "react";
import {Container, Row, Col, Card, CardBody, CardTitle, Button, Alert} from "reactstrap";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone,} from "react-bootstrap-table2-paginator";

import ToolkitProvider, {Search,} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import NewModal from "./NewModal";
import DeleteModal from "./DeleteModal";

import Breadcrumbs from "../../components/Common/Breadcrumb";

import {withTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {sectionsList} from "../../store/sections/actions";
import {connect} from "react-redux";

class Sections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sectionsData: [],
      loading: false,
      error: "",
      modalNew: false,
      modalDelete: false,
      sectionData: null,
    }
    this.togNew = this.togNew.bind(this)
    this.togDelete = this.togDelete.bind(this)
  }

  componentDidMount() {
    const {onSectionsList} = this.props;
    onSectionsList({history: this.props.history});
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        sectionsData: this.props.response.response ? this.props.response.response : [],
        loading: this.props.loading,
        error: this.props.error
      });
    }
  }

  togNew(data = null, action) {
    this.setState(prevState => ({
      action: action,
      sectionData: data,
      modalNew: !prevState.modalNew,
    }))
  }

  togDelete(data) {
    this.setState(prevState => ({
      sectionData: data,
      modalDelete: !prevState.modalDelete,
    }))
  }

  render() {
    const actionFormatter = (cell, row) => {
      return (<div>
        <Button color="success" className="me-2 mb-2" onClick={() => this.togNew({id: row.id, name: row.name, company: row.company}, "edit")}>Edit</Button>
        <Button color="danger" className="me-2 mb-2" onClick={() => this.togDelete({id: row.id, name: row.name})}>Delete</Button>
      </div>);
    }

    const columns = [{
      dataField: "id", text: "Id", sort: true,
    }, {
      dataField: "name", text: "Name", sort: true,
    }, {
      dataField: "company.label", text: "Company", sort: true,
    }, {
      dataField: "created", text: "Created", sort: true,
    }, {
      dataField: "", text: "Actions", sort: true, formatter: actionFormatter,
    },];

    const defaultSorted = [{
      dataField: "id", order: "asc",
    },];

    const pageOptions = {
      sizePerPage: 10, totalSize: this.state.sectionsData.length, custom: true, sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }]
    };

    const {SearchBar} = Search;

    function onColumnMatch({searchText, value, column, row}) {
      if (row.name.toLowerCase().includes(searchText) || row.company !== null && row.company.label.toLowerCase().includes(searchText) || row.created.includes(searchText))
        return true
      return false
    }

    document.title = "Sections | FileJet";

    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={this.props.t("FileJet")}
            breadcrumbItem={this.props.t("Sections")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={columns}
                    data={this.state.sectionsData}
                  >
                    {({paginationProps, paginationTableProps}) => (<ToolkitProvider
                      keyField="id"
                      columns={columns}
                      data={this.state.sectionsData}
                      search={{onColumnMatch}}
                    >
                      {toolkitProps => (<React.Fragment>
                        <Row className="mb-2">
                          <Col md="8">
                            <div>
                              <Button color="primary" onClick={() => this.togNew({}, "new")}>
                                New
                              </Button>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="search-box me-2 mb-2 d-inline-block float-end">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} placeholder="Filter"/>
                                <i className="bx bx-search-alt search-icon"/>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                classes={"table align-middle table-nowrap"}
                                headerWrapperClasses={"thead-light"}
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-md-center mt-30">
                          <Col className="inner-custom-pagination d-flex">
                            <div className="d-inline">
                              <SizePerPageDropdownStandalone {...paginationProps}/>
                            </div>
                            <div className="text-md-right ms-auto">
                              <PaginationListStandalone {...paginationProps}/>
                            </div>
                          </Col>
                        </Row>
                      </React.Fragment>)}
                    </ToolkitProvider>)}
                  </PaginationProvider>
                  {this.state.loading && (<div className="d-flex justify-content-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>)}
                  {this.state.error.length > 0 && (<div className="mt-3">
                    <Alert color="danger" role="alert">
                      {this.state.error}
                    </Alert>
                  </div>)}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.modalNew && <NewModal togModal={this.togNew} action={this.state.action} sectionsRefresh={this.props.onSectionsList} sectionData={this.state.sectionData} history={this.props.history}/>}
          {this.state.modalDelete && <DeleteModal togModal={this.togDelete} sectionsRefresh={this.props.onSectionsList} sectionData={this.state.sectionData} history={this.props.history}/>}
        </Container>
      </div>
    </React.Fragment>);
  }
}

Sections.propTypes = {
  response: PropTypes.any, onSectionsList: PropTypes.func,
};

const mapStateToProps = ({Sections}) => ({
  response: Sections.responseList,
  loading: Sections.loadingList,
  error: Sections.errorList,
});

const mapDispatchToProps = dispatch => ({
  onSectionsList: data => dispatch(sectionsList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Sections));
